var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIngredients(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.811,
    height: 14.957,
    viewBox: "0 0 16.811 14.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1991",
    "data-name": "Group 1991",
    transform: "translate(22912.91 -14239.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_newspaper-variant-outline",
    "data-name": "Path / newspaper-variant-outline",
    d: "M14.648,17.184H5.162M16.229,5H3.581A1.679,1.679,0,0,0,2,6.773V17.184a1.679,1.679,0,0,0,1.581,1.773H16.229a1.679,1.679,0,0,0,1.581-1.773V6.773A1.679,1.679,0,0,0,16.229,5m-1.581,8.638H5.162v1.773h9.486V13.638M8.324,6.546H5.162v5.319H8.324V6.546M9.905,8.319h4.743V6.546H9.905V8.319m4.743,1.773H9.905v1.773h4.743Z",
    transform: "translate(-22914.41 14235.271)",
    fill: "#c4ced5",
    stroke: "#587386",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2829",
    "data-name": "Path 2829",
    d: "M-22908.34,14242.546h2.893v4.894h-2.893Z",
    transform: "translate(-0.929 -0.485)",
    fill: "#587386",
    stroke: "#587386",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngredients);
export default __webpack_public_path__ + "static/media/ingredients.9b8a0a51f18a95b0cec1dd8bae8faef6.svg";
export { ForwardRef as ReactComponent };